import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Heading from '@/components/atoms/Heading';
const NoListingResults = ({ title, text }) => {
    return (_jsx("div", { className: "grid-base grid-cols-12 gap-1.5 py-4 md:gap-2.5 md:py-7.5", children: _jsxs("div", { className: "col-span-12 flex flex-col items-center gap-2 text-center text-text-body md:col-span-10 md:col-start-2", children: [_jsx(Heading, { variant: "ex-md", children: title }), text && _jsx("div", { className: "rich-text type-body-md", dangerouslySetInnerHTML: { __html: text } })] }) }));
};
export default NoListingResults;
